exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label {\n\tfont-size: 10pt;\n\tfont-weight: normal;\n\tcolor: #444;\n}\n\n.selectedRow,  .selectedRow:hover {\n\tbackground-color: #a1d6a2;\n}\n\n.srm-sort-link {\n\tcolor: white;\n\ttext-decoration: none;\n\tfont-weight: bold;\n}\n\n.user-badge {\n\tdisplay: inline-block;\n\tpadding: 5px 10px;\n\tbackground-color: #2f71b8; \n\tcolor: white;\n\tborder-radius: 5px; \n\tmargin: 0 5px 5px 0; \n\tfont-size: 14px;\n  }\n  \n  .user-added {\n\tbackground-color: #28a745; \n\tcolor: white; \n  }\n  \n  .btn-spacing {\n\tmargin-bottom: 5px;\n  }\n\n  .readonly-style {\n  \tbackground-color: #f0f0f0;\n  \tcolor: #888;\n  \tborder: 1px dashed #ccc;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/offers/offers.component.css
// module id = 347
// module chunks = 0